export const GHOST_URL = '/ghosted';

export const ORIGINAL_USER_SESSION_KEY = 'originalUser';
